var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.2 7.2 C 9.6 6.0 12.0 6.0 13.4 7.2 L 17.2 10.6 C 18.0 11.3 18.4 12.1 18.2 13.1 L 17.2 18.8 C 17.0 19.8 15.9 20.5 14.8 20.5 L 6.8 20.5 C 5.7 20.5 4.6 19.8 4.4 18.8 L 3.4 13.1 C 3.2 12.1 3.6 11.3 4.4 10.6 L 8.2 7.2 Z",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.5 14.8 C 8.7 14.8 8 15.4 8 16.2 L 8 17.4 C 8 18.2 8.7 18.8 9.5 18.8 C 10.3 18.8 11 18.2 11 17.4 L 11 16.2 C 11 15.4 10.3 14.8 9.5 14.8 Z",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fd72a3512e45f2a3f83d5ef61361b4c6.svg";
export { ForwardRef as ReactComponent };